import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Button, Input, Breadcrumbs } from '../../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import { translate, formatData, getUserNameToName } from '../../../utils/util';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';

const PartNumberQuantityInsert = (props) => {
    const [partNumberQuantity, setPartNumberQuantity] = useState(props.location?.state?.update && props.partNumberQuantity ? props.partNumberQuantity : {});
    const update = props.location?.state?.update;

    const subtitles = () => {
        return [{ icon: "mdi mdi-plus-box-outline", label: update ? translate('menu.update', 'configuration') : translate('menu.insert', 'configuration') }];
    }

    const onChange = (event) => {
        onValueChange(event, partNumberQuantity, setPartNumberQuantity);
    };

    const redirect = () => {
        props.history.replace('./list');
    }

    const onConfirm = () => {
        if (validateInputsRequired("formPartNumberQuantityInsert")) {
            if (update) {
                props.update(partNumberQuantity, () => {
                    redirect();
                });
            } else {
                props.add(partNumberQuantity, () => {
                    redirect();
                });
            }
        }
    };

    return (
        <div>
            <Breadcrumbs id="partNumberInsert" title={{ icon: "mdi mdi-clipboard-check-outline", label: translate('cimpallet', 'partnumber-quantity') }} subtitles={subtitles()} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <div id="formPartNumberQuantityInsert" className="row" style={{ marginBottom: '0px' }}>
                                <div className="input-field no-padding col s12">
                                    <Input onChange={onChange} leadingzeros={11} disabled={update} required label={translate('fields.partNumberCode', 'partnumber-quantity')} id="partNumberCode " name="partNumberCode" type="text" value={partNumberQuantity.partNumberCode || ''} numericonly="true" />
                                </div>
                                <div className="input-field no-padding col s12">
                                    <Input onChange={onChange} required label="MDR" id="mdr" name="mdr" type="text" value={partNumberQuantity.mdr || ''} maxLength={10} />
                                </div>
                                <div className="input-field no-padding col s12">
                                    <Input onChange={onChange} required label={translate('fields.quantity', 'partnumber-quantity')} id="quantity" name="quantity" type="number" step={1} value={partNumberQuantity.quantity || ''} />
                                </div>
                                {update &&
                                    <div>
                                        <div className="input-field no-padding col s12">
                                            <Input required label={translate('fields.updateBy', 'partnumber-quantity')} id="updateBy" name="updateBy" type="text" defaultValue={getUserNameToName(props?.usersFromElog, partNumberQuantity?.updatedBy)} disabled />
                                        </div>
                                        <div className="input-field no-padding col s12">
                                            <Input required label={translate('fields.updateOn', 'partnumber-quantity')} id="updateOn" name="updateOn" type="text" defaultValue={formatData(partNumberQuantity?.updatedOn)} disabled />
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="row" style={{ paddingTop: '10px' }}>
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        partNumberQuantity: state.physicalConfirmationReducer.partNumberQuantity,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        add: (partNumberQuantity, callback) => {
            dispatch(PhysicalConfirmationService.addPartNumberQuantity(partNumberQuantity, callback));
        },
        update: (partNumberQuantity, callback) => {
            dispatch(PhysicalConfirmationService.updatePartNumberQuantity(partNumberQuantity, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PartNumberQuantityInsert)));
